import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const scrollingShowcaseWrapperDefinition: ComponentDefinition = {
  id: 'scrolling-showcase-wrapper',
  name: 'Scrolling Showcase',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/gallery-horizontal-end.svg',
  children: true,
  variables: {
    logoDisplay: {
      type: 'Text',
      displayName: 'Logo display',
      defaultValue: 'circular',
      group: 'style',
      validations: {
        in: [
          { value: 'circular', displayName: 'Circular' },
          { value: 'natural', displayName: 'Natural' },
        ],
        bindingSourceType: ['manual'],
      },
    },
    enableCarousel: {
      type: 'Boolean',
      displayName: 'Enable Carousel',
      defaultValue: true,
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    enableAutoscroll: {
      type: 'Boolean',
      displayName: 'Auto-scroll',
      defaultValue: false,
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    scrollSpeed: {
      type: 'Number',
      displayName: 'Scroll speed (seconds)',
      defaultValue: 3,
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    logosPerSlide: {
      type: 'Number',
      displayName: 'Logos per slide (desktop)',
      defaultValue: 0,
      description: 'Set to 0 for auto-sizing',
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    mobileLogosPerSlide: {
      type: 'Number',
      displayName: 'Logos per slide (mobile)',
      defaultValue: 0,
      description: 'Set to 0 for auto-sizing',
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    logoMaxHeight: {
      type: 'Number',
      displayName: 'Logo max height (px)',
      defaultValue: 0,
      description: 'Maximum height for logos in pixels. Set to 0 for default.',
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    logoSpacing: {
      type: 'Number',
      displayName: 'Logo spacing (px)',
      defaultValue: 0,
      description: 'Gap between logos in pixels. Set to 0 for default (20px).',
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    centerDotsOnMobile: {
      type: 'Boolean',
      displayName: 'Center navigation on mobile',
      defaultValue: false,
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
  },
} as const;
